// extracted by mini-css-extract-plugin
export default {"fullWidth":"Po-z","image":"Qo-z","lazyLoadPicture":"Ro-z","lazyLoadSpinner":"So-z","lazyLoadSpin":"To-z","lazyLoadImage":"Uo-z","hasStyledAspectRatio":"Vo-z"};